<template>
  <div class="charts-panel">
    <button type="button" class="charts-panel__toggle" :aria-expanded="open" @click="toggle">
      <span>{{ title }}</span>
      <i
        class="el-icon-arrow-down charts-panel__arrow"
        :class="{ 'is-open': open }"
        aria-hidden="true"
      />
    </button>
    <div v-if="open" class="charts-panel__body">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ChartsPanel',
  props: {
    title: { type: String, default: '图表分析' },
    defaultOpen: { type: Boolean, default: false },
  },
  data() {
    return { open: this.defaultOpen };
  },
  methods: {
    toggle() {
      this.open = !this.open;
      this.$emit('change', this.open);
    },
  },
});
</script>

<style lang="scss" scoped>
.charts-panel {
  background: $color-surface;
  border: 1px solid $color-border;
  border-radius: $border-radius-base;

  &__toggle {
    width: 100%;
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 600;
    color: $color-text;
    cursor: pointer;
    user-select: none;

    &:hover {
      color: $color-primary;
    }
  }

  &__arrow {
    color: $color-text-secondary;
    transition: transform 0.2s ease;

    &.is-open {
      transform: rotate(180deg);
    }
  }

  &__body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 0 16px 16px;
  }
}

::v-deep .chart-card {
  padding: 12px;
  background: $color-surface-muted;
  border-radius: $border-radius-sm;

  .chart-card__title {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 600;
    color: $color-text-secondary;
  }

  .chart-card__empty {
    padding: 60px 0;
    font-size: 12px;
    text-align: center;
    color: $color-text-secondary;
  }

  &.chart-card--full {
    grid-column: 1 / -1;
  }
}
</style>
